
import { RadioElement } from '05-ui-kit';
import { formatPrice } from '@artmizu/utils';
import type { Seller } from '~/type/Seller';
interface Props {
  list: Seller[];
  value?: Seller;
}
const __sfc_main = {};
__sfc_main.props = {
  list: {
    key: "list",
    required: true,
    type: Array
  },
  value: {
    key: "value",
    required: false,
    type: null
  }
};
__sfc_main.setup = (__props, __ctx) => {
  const emit = __ctx.emit;
  function onSellerChange(seller: Seller) {
    emit('change', seller);
  }
  function beautifyPrice(price: string) {
    return price ? `${formatPrice(price)}₽` : price;
  }
  return {
    onSellerChange,
    beautifyPrice
  };
};
__sfc_main.components = Object.assign({
  RadioElement
}, __sfc_main.components);
export default __sfc_main;
